@if (
  {
    row: columnData | async,
    keyname: keyName | async,
  };
  as $
) {
  @if ($.row && $.keyname) {
    <span>{{ $.row[$.keyname] | number: '1.2-2' }}</span>
  }
}
